module.exports = __webpack_public_path__ + "img/taxis.fcdb2e7b.png";